export default __webpack_public_path__ + "static/noise-4c2f4aa9d54c0467eafaaef8b756e8f7.png";